import React from 'react';
import PropTypes from 'prop-types';
import { signup } from '../../client/action/navigateAuthentication';

const TryBanner = (props, context) => (
  <div id="try-banner" data-swiftype-index='false'>
    <div className="try-banner try-banner-alt">
      <span>Use Auth0 for FREE</span>
      <button onClick={() => context.executeAction(signup)} className="btn btn-success btn-lg">Create free Account</button>
    </div>
  </div>
);

TryBanner.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

export default TryBanner;
